// externals
import thunk from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import { routerMiddleware } from 'connected-react-router';

// utils
import { historyInstance } from '@makemydeal/dr-shared-store';

// middleware
import { applicationLoadErrorMiddleware } from '../middleware/applicationLoadErrorMiddleware';
import { embeddedSessionExpiredMiddleware } from '../middleware/embeddedSessionExpiredMiddleware';
import { bootstrapMiddleware } from '../middleware/bootstrapMiddleware';
import { saveParticipantsPayloadMiddleware } from '../middleware/saveParticipantsPayloadMiddleware';
import { tradeInRouterMiddleware } from '@makemydeal/activities-tradein';
import {
    correlationMiddleware,
    cdlV3AnalyticsEventMiddleware,
    loadCdlV3ScriptMiddleware
} from '@makemydeal/dr-sales-checkin-store';

export const getInitialMiddleware = () => [
    thunk,
    correlationMiddleware,
    // Must run BEFORE apiMiddleware so it can rewrite the customer-card activity's save-participants
    // RSAA body before the HTTP request is issued.
    saveParticipantsPayloadMiddleware,
    apiMiddleware,
    bootstrapMiddleware,
    // Must run AFTER bootstrapMiddleware, which dispatches the INIT_PENCIL_* actions this
    // guard's post-init rules key on.
    applicationLoadErrorMiddleware,
    embeddedSessionExpiredMiddleware,
    // Must run BEFORE routerMiddleware so trade-in route navigations are redirected
    // into the trade-in in-memory history instead of the shared browser history.
    tradeInRouterMiddleware,
    routerMiddleware(historyInstance),
    loadCdlV3ScriptMiddleware,
    cdlV3AnalyticsEventMiddleware
];
